import React, { Suspense, useEffect } from 'react';
import Loading from './components/Loading';
import { useAuth } from './context/AuthContext';
import useUrlSearchParams from './hooks/useUrlSearchParams';
import theme from './utils/theme';
import useCustomCompany from './hooks/useCustomCompany';

const AuthenticatedApp = React.lazy(() => import('./AuthenticatedApp'));
const UnauthenticatedApp = React.lazy(() => import('./UnauthenticatedApp'));

const App = () => {
  const { searchParams } = useUrlSearchParams();
  const { token } = searchParams;

  const { user, loginWithToken } = useAuth();
  const { HelmetComponent } = useCustomCompany();

  useEffect(() => {
    if (token) loginWithToken({ token });
  }, [token, loginWithToken]);

  return (
    <>
      {HelmetComponent}
      <Suspense fallback={<Loading color={theme.colors.secondary} />}>
        {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
      </Suspense>
    </>
  );
};

export default App;
